import {
    NT_SEARCH_MARKETING_PRODUCT_KEY,
    NT_DISPLAY_MARKETING_PRODUCT_KEY,
    NT_AFFILIATE_MARKETING_PRODUCT_KEY,
    NT_ESSENTIAL_PRODUCT_KEY,
    NT_ADVANCED_PRODUCT_KEY,
} from "app/constants/ntProductKeys";
import type { INavigationTileProps } from "app/pages/digital-marketing/home-pages/MajorNavigationTile";
import type { ReactNode } from "react";

type NoTouchUserType =
    | typeof NT_SEARCH_MARKETING_PRODUCT_KEY
    | typeof NT_DISPLAY_MARKETING_PRODUCT_KEY
    | typeof NT_AFFILIATE_MARKETING_PRODUCT_KEY
    | typeof NT_ESSENTIAL_PRODUCT_KEY
    | typeof NT_ADVANCED_PRODUCT_KEY;

export type NavigationTile = INavigationTileProps & {
    userTypes?: NoTouchUserType[];
    redirectPageText?: string;
    pill?: () => ReactNode;
};

export const navigationTiles: NavigationTile[] = [
    {
        id: "websiteAnalysis",
        title: "digitalmarketing.homepage.website.analysis.title",
        subTitle: "digitalmarketing.homepage.website.analysis.subtitle",
        redirectPageText: "digitalmarketing.homepage.website.analysis.redirect.subtitle",
        iconName: "website-analysis",
        navigationState: "digitalsuite_website_websiteperformance",
        useRedirect: true,
    },
    {
        id: "websiteKeywords",
        title: "digitalmarketing.homepage.website.keywords.title",
        subTitle: "digitalmarketing.homepage.website.keywords.subtitle",
        redirectPageText: "digitalmarketing.homepage.website.keywords.redirect.subtitle",
        iconName: "search-interest-analysis",
        navigationState: "organicsearch_websites_v2_traffic_keywords",
        useRedirect: true,
    },
    {
        id: "landingPages",
        title: "digitalmarketing.homepage.organic.landing.pages.title",
        subTitle: "digitalmarketing.homepage.organic.landing.pages.subtitle",
        redirectPageText: "digitalmarketing.homepage.organic.landing.pages.redirect.subtitle",
        iconName: "spaceship",
        navigationState: "organicsearch_website_landingpages_v2",
        useRedirect: true,
    },
    {
        id: "searchAds",
        title: "digitalmarketing.homepage.search.ads.title",
        subTitle: "digitalmarketing.homepage.search.ads.subtitle",
        redirectPageText: "digitalmarketing.homepage.search.ads.redirect.subtitle",
        iconName: "ad-tech",
        navigationState: "paidsearch_website_ads",
        useRedirect: true,
    },
    {
        id: "organicCompetitors",
        title: "digitalmarketing.homepage.organic.competitors.title",
        subTitle: "digitalmarketing.homepage.organic.competitors.subtitle",
        redirectPageText: "digitalmarketing.homepage.organic.competitors.redirect.subtitle",
        navigationState: "organicsearch_websites-competitorsKeywords",
        iconName: "megaphone",
        useRedirect: true,
        userTypes: [
            NT_DISPLAY_MARKETING_PRODUCT_KEY,
            NT_SEARCH_MARKETING_PRODUCT_KEY,
            NT_ESSENTIAL_PRODUCT_KEY,
            NT_ADVANCED_PRODUCT_KEY,
        ],
    },
    {
        id: "paidCompetitors",
        title: "digitalmarketing.homepage.paid.competitors.title",
        subTitle: "digitalmarketing.homepage.paid.competitors.subtitle",
        redirectPageText: "digitalmarketing.homepage.paid.competitors.redirect.subtitle",
        navigationState: "organicsearch_websites-competitorsKeywords",
        iconName: "paid-competitors",
        useRedirect: true,
        userTypes: [
            NT_AFFILIATE_MARKETING_PRODUCT_KEY,
            NT_DISPLAY_MARKETING_PRODUCT_KEY,
            NT_ESSENTIAL_PRODUCT_KEY,
            NT_ADVANCED_PRODUCT_KEY,
        ],
    },
    {
        id: "keywordGenerator",
        title: "digitalmarketing.homepage.keyword.generator.title",
        subTitle: "digitalmarketing.homepage.keyword.generator.subtitle",
        iconName: "page-with-coffee",
        navigationState: "digitalsuite_findkeywords_keywordGeneratorTool",
        userTypes: [NT_SEARCH_MARKETING_PRODUCT_KEY, NT_ESSENTIAL_PRODUCT_KEY, NT_ADVANCED_PRODUCT_KEY],
    },
    {
        id: "keywordAnalysis",
        title: "digitalmarketing.homepage.keyword.analysis.title",
        subTitle: "digitalmarketing.homepage.keyword.analysis.subtitle",
        iconName: "affiliates-keyword",
        navigationState: "organicsearch_keywordanalysis_home",
        userTypes: [NT_SEARCH_MARKETING_PRODUCT_KEY, NT_ESSENTIAL_PRODUCT_KEY, NT_ADVANCED_PRODUCT_KEY],
    },
];
